import types from "./types";
import { createReducer } from "utils/redux";

const initialLoadingState = {
    tableLoading: true,
};

const initialDialogState = {
    addWorkTypeDialog: false,
    deleteWorkTypeDialog: false,
    editWorkTypeDialog: false
};

const initialState = {
    loading: { ...initialLoadingState },
    dialog: { ...initialDialogState },
    workTypes: [],
};

const actionsMap = {
    [types.SET_LOADING_STATE]: (state, { payload }) => {
        const { key, value } = payload;
        return {
            ...state,
            loading: {
                ...state.loading,
                [key]: value,
            },
        };
    },
    [types.SET_WORK_TYPES_DATA]: (state, { payload }) => {
        const { workTypes } = payload;
        return {
            ...state,
            workTypes,
        };
    },
    [types.SET_DIALOG_STATE]: (state, { payload }) => {
        const { key, value } = payload;
        return {
            ...state,
            dialog: {
                ...state.dialog,
                [key]: value,
            },
        };
    }
}

export default createReducer(initialState, actionsMap); 